/**
 * Por qué falló, en una frase que el usuario pueda usar.
 *
 * «Falló» manda a adivinar. Un 403 es una conversación con el administrador; un
 * fichero demasiado grande es volver a escanearlo; un `timeout` es reintentar.
 * Son tres acciones distintas y hasta ahora las tres se contaban igual — o peor:
 * `QuickFillActions.js` respondía a un 403 con «las fechas ya estaban rellenas»,
 * inventando una causa benigna para un fallo de permisos.
 */

const POR_ESTADO = {
  400: 'los datos no son válidos',
  401: 'la sesión ha caducado',
  403: 'no tienes permiso',
  404: 'ya no existe',
  409: 'hay un conflicto con lo que ya había',
  413: 'el fichero es demasiado grande',
  422: 'los datos no son válidos',
  429: 'demasiadas peticiones seguidas',
};

/**
 * @param {*} error el error de axios (o cualquiera)
 * @param {string} [porDefecto] qué decir cuando no se reconoce nada
 * @returns {string} una causa en minúsculas, para encajarla en una frase
 */
export function describeApiFailure(error, porDefecto = 'no se pudo completar') {
  const estado = error?.response?.status;

  if (estado && POR_ESTADO[estado]) return POR_ESTADO[estado];
  if (estado >= 500) return 'el servidor dio un error';

  if (error?.code === 'ECONNABORTED') return 'el servidor tardó demasiado en responder';
  if (error?.code === 'ERR_NETWORK' || !estado) return 'no hubo respuesta del servidor';

  return porDefecto;
}

/**
 * El detalle que manda el backend, si lo hay; si no, la causa genérica.
 * Para mensajes de una sola acción, donde cabe el texto largo.
 */
export function apiFailureDetail(error, porDefecto = 'no se pudo completar') {
  const detalle = error?.response?.data?.detail;
  if (typeof detalle === 'string' && detalle.trim()) return detalle;
  return describeApiFailure(error, porDefecto);
}
